import EuropeTermsOfParticipation from './Europe/TermsOfParticipation';
import FranceTermsOfParticipation from './Europe/France/TermsOfParticipation';
import SpainTermsOfParticipation from './Europe/Spain/TermsOfParticipation';
import SwitzerlandTermsOfParticipation from './Europe/Switzerland/TermsOfParticipation';
import BelgiumTermsOfParticipation from './Europe/Belgium/TermsOfParticipation';
import USTermsOfParticipation from './America/US/TermsOfParticipation';
import CanadaTermsOfParticipation from './America/Canada/TermsOfParticipation';
import { COUNTRY } from '../CountryUtils';

const termsOfParticipation = {
    [COUNTRY.UK]: EuropeTermsOfParticipation,
    [COUNTRY.FRANCE]: FranceTermsOfParticipation,
    [COUNTRY.SPAIN]: SpainTermsOfParticipation,
    [COUNTRY.GERMANY]: EuropeTermsOfParticipation,
    [COUNTRY.SWITZERLAND]: SwitzerlandTermsOfParticipation,
    [COUNTRY.BELGIUM]: BelgiumTermsOfParticipation,
    [COUNTRY.US]: USTermsOfParticipation,
    [COUNTRY.CANADA]: CanadaTermsOfParticipation,
};

export const getTermsOfParticipationByCountry = (country) =>
    termsOfParticipation[country];
